module.exports = __webpack_public_path__ + "static/performance-ffb8cb6cfa7c531e44fc6543b2c211b9.svg";